"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.popinFactory = void 0;
var utils_1 = require("@lglp/utils");
var popin_1 = require("../../../types/entities/documents/popin");
var tile_1 = require("../../field-groups/tile");
var fields_1 = require("../../fields");
var page_factory_1 = require("./pages/page-factory");
var POPIN_THEME_PRISMIC_TO_LGLP = {
    'Fond jaune': popin_1.PopinTheme.yellow,
    'Fond turquoise': popin_1.PopinTheme.light_turquoise,
    'Fond bleu ciel': popin_1.PopinTheme.pale_blue,
    'Fond bleu foncé': popin_1.PopinTheme.blue,
    'Fond jaune nouvelle identité': popin_1.PopinTheme.yellow,
    'Fond bleu nouvelle identité': popin_1.PopinTheme.darkish_blue,
    'Fond vert nouvelle identité': popin_1.PopinTheme.green,
    'Fond turquoise nouvelle identité': popin_1.PopinTheme.turquoise
};
var processPopin = function (prismicPage, normalizedPage, logger) {
    return utils_1.compact(__assign(__assign({}, normalizedPage), { theme: logger.toConstValue(prismicPage.data.theme, POPIN_THEME_PRISMIC_TO_LGLP), parent: fields_1.toLink(prismicPage.data.parent, logger), tile: tile_1.toTile(prismicPage.data, logger) }));
};
var popinFactory = function (type, next) {
    return page_factory_1.pageFactory(type, function (prismicPage, normalizedPage, logger) {
        var normalizedPopin = processPopin(prismicPage, normalizedPage, logger);
        return next(prismicPage, normalizedPopin, logger);
    });
};
exports.popinFactory = popinFactory;
//# sourceMappingURL=popin-factory.js.map